<mat-spinner *ngIf="!loaded" diameter="50"></mat-spinner>

<div class="save-header" *ngIf="loaded">
  <h2 data-test="title-specialties">Specialties</h2>

  <div>
    <iris-button
      (click)="onCancel()"
      [disabled]="saving"
      [buttonType]="IrisButtonTypes.SECONDARY"
      aria-label="Cancel"
      data-test="cancel-specialties-changes"
    >
      Cancel
    </iris-button>
    <iris-button
      (click)="onSave()"
      [disabled]="saving"
      aria-label="Save"
      data-test="save-specialties-changes"
    >
      Save
    </iris-button>
  </div>
</div>

<iris-card *ngIf="loaded">
  <h3
    class="no-margin"
    [ngClass]="{ 'error error-h3' : !topSpecialtySelected }"
    data-test="top-specialties"
  >
    Top specialties
  </h3>
  <span class="error" *ngIf="!topSpecialtySelected">This is a required question. You must select a response.</span>
  <div class="iris-body-responsive specialty-required-text">
    Choosing at least 1 top specialty is required.
  </div>
  <section title="top-specialties" class="specialty-selector-wrapper">
    <member-profile-specialty-selector
      [form]="topForm"
      [specialtiesRefData]="specialties()"
      name="topSpecialty1"
      label="Top Specialty 1"
      data-test="top-specialty-1"
    ></member-profile-specialty-selector>
    <member-profile-specialty-selector
      [form]="topForm"
      [specialtiesRefData]="specialties()"
      name="topSpecialty2"
      label="Top Specialty 2"
      data-test="top-specialty-2"
    ></member-profile-specialty-selector>
    <member-profile-specialty-selector
      [form]="topForm"
      [specialtiesRefData]="specialties()"
      name="topSpecialty3"
      label="Top Specialty 3"
      data-test="top-specialty-3"
    ></member-profile-specialty-selector>
  </section>

  <h3 data-test="other-specialties">Other specialties</h3>
  <sondermind-reference-datum-checklist
    [form]="checkedForm"
    [refDatumItems]="specialties()"
    [columns]="3"
    [order]="RefDatumOrder.row"
    data-test="other-specialties-checkbox"
  ></sondermind-reference-datum-checklist>
</iris-card>
